import React from "react";

import { IconBoxProps } from "./IconBoxTypes";
import useIconBoxStyles from "./useIconBoxStyles";

const IconBox: React.FC<IconBoxProps> = props => {
  const classes = useIconBoxStyles(props);

  return <div className={classes.icon}>{props.children}</div>;
};

export default IconBox;
